$(document).ready(function () {
  if ($('.frame').data('page') == 'about') {
    // aboutBanner
    const aboutBannerAni = gsap.timeline();
    const filaments = document.querySelectorAll(".filament");
    filaments.forEach((path) => {
      const length = path.getTotalLength();
      gsap.set(path, { strokeDasharray: length, strokeDashoffset: length });
    });
    aboutBannerAni
      .from("#about-paper", { duration: 0.5, scale: 0, ease: 'circ.out' })
      .from("#about-rect", { duration: 0.5, scale: 0, ease: 'circ.out' })
      .from(".about-hand-img", { delay: 0.1, duration: 0.5, y: 400, x: 0, ease: 'circ.out' })
      .to(".filament-right", { duration: 0.3, strokeDashoffset: 0, ease: "power1.inOut" })
      .to(".filament-left", { duration: 0.5, strokeDashoffset: 0, ease: "power1.inOut" })
      .to("#light-filament", { duration: 1, filter: "drop-shadow(0 0 15px rgba(255, 255, 255, 0.8))", ease: "sine.inOut" }, "-=0.5")
      .from(".showcase_bn_arrow", { delay: 0.5, duration: 0.5, opacity: 0, y: -20, stagger: 0.5, repeat: -1, repeatDelay: 3, })

    
    let mm = gsap.matchMedia();
    mm.add("(max-width: 1024px)", () => {

      // aboutFeature
      let aboutFeature_tl = gsap.timeline({
        scrollTrigger: {
          trigger: "#aboutFeature",
          start: "top 50%",
        }
      });
      aboutFeature_tl
        .from(".item-website .feature-item-inner", { duration: 0.5, scale: 0, ease: 'circ.out' })
        .from(".item-ai .feature-item-inner", { duration: 0.5, scale: 0, ease: 'circ.out' })
        .from(".item-geo .feature-item-inner", { duration: 0.5, scale: 0, ease: 'circ.out' })
    });

    mm.add("(min-width: 1025px)", () => {
      
      // aboutFeature
      let aboutFeature_tl = gsap.timeline({
        scrollTrigger: {
          trigger: "#aboutFeature",
          start: "top 10%",
          end: "+=1000",
          scrub: 1,
          pin: true,
          anticipatePin: 1,
        }
      });
      gsap.set(".dash-circle", { transformOrigin: "center center" });
      const maskPaths = document.querySelectorAll(".dash-line-mask");
      maskPaths.forEach((path) => {
        const length = path.getTotalLength();
        gsap.set(path, { strokeDasharray: length, strokeDashoffset: length });
      });
      aboutFeature_tl
        .from(".item-website .dash-circle", { duration: 0.5, scale: 0, ease: "back.out(1.7)" })
        .to(".item-website .dash-line-mask", { duration: 0.8, strokeDashoffset: 0, ease: "power2.inOut" }, "-=0.2")
        .from(".item-website .feature-item-inner", { delay: 0.1, duration: 0.5, scale: 0, ease: 'back.out(1.7)' }, "-=0.2")
        .from(".item-ai .dash-circle", { duration: 0.5, scale: 0, ease: "back.out(1.7)" })
        .to(".item-ai .dash-line-mask", { duration: 0.8, strokeDashoffset: 0, ease: "power2.inOut" }, "-=0.2")
        .from(".item-ai .feature-item-inner", { delay: 0.1, duration: 0.5, scale: 0, ease: 'back.out(1.7)' }, "-=0.2")
        .from(".item-geo .dash-circle", { duration: 0.5, scale: 0, ease: "back.out(1.7)" })
        .to(".item-geo .dash-line-mask", { duration: 0.8, strokeDashoffset: 0, ease: "power2.inOut" }, "-=0.2")
        .from(".item-geo .feature-item-inner", { delay: 0.1, duration: 0.5, scale: 0, ease: 'back.out(1.7)' }, "-=0.2");

    });

    // All media width
    mm.add("all", () => {

      // aboutMission
      let aboutMission_tl = gsap.timeline({
        scrollTrigger: {
          trigger: "#aboutMission",
          start: "top center",
          end: "bottom 90%",
          scrub: 1,
          // markers: true,
        }
      });
      aboutMission_tl
        .to(".about-mission-bg", { scale: 1.5 })
 
      
      // aboutWhyDo - sean img
      let aboutWhyDo_tl = gsap.timeline({
        scrollTrigger: {
          trigger: "#aboutWhyDo .sean-brand-img",
          start: "top 50%",
        }
      });
      gsap.set("#cianwang-logo", { transformOrigin: "right bottom" });
      gsap.set(".rect-blue", { transformOrigin: "center center" });
      gsap.set(".rect-white", { transformOrigin: "center center" });
      aboutWhyDo_tl
        .from("#cianwang-logo", { duration: 0.5, scale: 0, ease: 'circ.out' })
        .from(".rect-white", { duration: 0.5, scale: 0, ease: 'circ.out' }, "-=0.2")
        .from(".sean-img", { delay: 0.3, duration: 0.5, y: 800, x: 0, ease: 'circ.out' })
        .from(".rect-blue", { duration: 0.2, scale: 0, ease: 'circ.out' })

        
      // aboutJourney - Step 1
      let aboutJourney_tl = gsap.timeline({
        scrollTrigger: {
          trigger: ".steps-item-wrap.step-1",
          start: "top 50%",
        }
      });
      aboutJourney_tl
        .from(".steps-item-wrap.step-1 .steps-item .image-wrap", { duration: 0.5, scale: 0, ease: 'circ.out' })
        .from(".steps-item-wrap.step-1 .steps-item .text-wrap", { duration: 0.7, x: -30, opacity: 0, ease: 'circ.out' }, "-=0.2")
        .from(".steps-item-wrap.step-1 .arrow-down", { duration: 0.3, opacity: 0, y: -5, stagger: 0.1 })

      // aboutJourney - Step 2
      let aboutJourney_t2 = gsap.timeline({
        scrollTrigger: {
          trigger: ".steps-item-wrap.step-2",
          start: "top 50%",
        }
      });
      aboutJourney_t2
        .from(".steps-item-wrap.step-2 .steps-item .image-wrap", { duration: 0.5, scale: 0, ease: 'circ.out' })
        .from(".steps-item-wrap.step-2 .steps-item .text-wrap", { duration: 0.7, x: -30, opacity: 0, ease: 'circ.out' }, "-=0.2")
        .from(".steps-item-wrap.step-2 .arrow-down", { duration: 0.3, opacity: 0, y: -5, stagger: 0.1 })

      // aboutJourney - Step 3
      let aboutJourney_t3 = gsap.timeline({
        scrollTrigger: {
          trigger: ".steps-item-wrap.step-3",
          start: "top 50%",
        }
      });
      aboutJourney_t3
        .from(".steps-item-wrap.step-3 .steps-item .image-wrap", { duration: 0.5, scale: 0, ease: 'circ.out' })
        .from(".steps-item-wrap.step-3 .steps-item .text-wrap", { duration: 0.7, x: -30, opacity: 0, ease: 'circ.out' }, "-=0.2")
        .from(".steps-item-wrap.step-3 .arrow-down", { duration: 0.3, opacity: 0, y: -5, stagger: 0.1 })

      // aboutJourney - Step 4
      let aboutJourney_t4 = gsap.timeline({
        scrollTrigger: {
          trigger: ".steps-item-wrap.step-4",
          start: "top 50%",
        }
      });
      aboutJourney_t4
        .from(".steps-item-wrap.step-4 .steps-item .image-wrap", { duration: 0.5, scale: 0, ease: 'circ.out' })
        .from(".steps-item-wrap.step-4 .steps-item .text-wrap", { duration: 0.7, x: -30, opacity: 0, ease: 'circ.out' }, "-=0.2")
        .from(".steps-item-wrap.step-4 .arrow-down", { duration: 0.3, opacity: 0, y: -5, stagger: 0.1 })

      // aboutJourney - Step 5
      let aboutJourney_t5 = gsap.timeline({
        scrollTrigger: {
          trigger: ".steps-item-wrap.step-5",
          start: "top 50%",
        }
      });
      aboutJourney_t5
        .from(".steps-item-wrap.step-5 .steps-item .image-wrap", { duration: 0.5, scale: 0, ease: 'circ.out' })
        .from(".steps-item-wrap.step-5 .steps-item .text-wrap", { duration: 0.7, x: -30, opacity: 0, ease: 'circ.out' }, "-=0.2")

    });
  }
});
